import styled from "styled-components";
import { useRef, useState } from "react";
import {
  GoogleMap,
  Marker,
  MarkerClusterer,
} from "@react-google-maps/api";
import { useDispatch } from "react-redux";
import { showModal, showNestedModal } from "../../features/modal/modalSlice";
import {
  getShipmentDriverLocationsById,
  setIsActiveSide,
  setTopPagesMapShipmentItemCurrentLocationData,
} from "../../features/topPagesMap/topPagesMapSlice";
import avatar from "../../images/img/avatar.jpg";
import { getSingleShipmentLoadItem } from "../../features/loadList/loadListSlice";
import { useSelector } from "react-redux";
import MemoizedOverlayDriverLocation from "./overlays/MemoizedOverlayDriverLocation";
import { setSelectUserData } from "../../features/user/userSlice";
import getPastDateAndTime from "../../helper/date/getPastDateAndTime";
import { useEffect } from "react";
import getDistance from "../../helper/distance/getDistance";
import bayrak from "../../images/svg/bayrak.svg"
import bayrakk from "../../images/svg/bayrakk.svg"
import locationData from "../../utils/locationData/locationOptions";
import { getDistanceBetweenTwoTown } from "../../features/distance/distanceSlice";
import getTekSuruculuTahminiVaris from "../../helper/topPagesMap/getTekSuruculuTahminiVaris";
import getCiftSuruculuTahminiVaris from "../../helper/topPagesMap/getCiftSuruculuTahminiVaris";
import { TbTriangleInvertedFilled } from "react-icons/tb";
import addThreeHoursToISO from "../../helper/date/addThreeHoursToISO";
import { useLocation } from "react-router-dom";
import addLoadLocationData from "../../utils/locationData/addLoadLocationOptions";
import SmallSpinner from "../shared/spinners/SmallSpinner";
import moment from "moment";


const Container = styled.div`
  width: 100%;
  height: 600px;
  display: flex;

  .map-side-container {
    width: 260px;
    height: 100%;
    background-color: var(--color-main);
    color: #fff;

    .side-top-container {
      border-bottom: 1px solid #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 25px 20px;

      .top-data-container {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .top-data-name {
          font-size: var(--font-size-md);
          font-weight: var(--font-weight-lg);
        }

        .top-data-phone {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
        }
      }

      .top-img-container {
        width: 70px;
        height: 70px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover !important;
        }
      }
    }
    

    .side-mid-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 30px;
      padding: 25px 20px;
      margin-bottom: auto;

      .side-mid-item {
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
      }

      .varis{
        display: flex;
        flex-direction: column;
        gap: 3px;
        font-size: var(--font-size-sm);

        .tahmini-varis-container{
          position: relative;

          p{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
            position: absolute;
            bottom:35px;
            background-color: ${({theme}) => theme.secondaryBgColor};
            color: ${({theme}) => theme.mainTextColor};
            border-radius: 10px;
            padding: 10px;
          }

          .arr{
            position: absolute;
            bottom:22px;
            left: 37%;

          }
        }

        .varis-date{
          font-size: 12px;
        }
        .question-mark{
          cursor: pointer;


        }
      }
    }

    .side-bottom-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      padding: 25px 20px;
      border-top: 1px solid #fff;

      button {
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-xl);
        padding: 5px 15px;
        border-radius: 5px;
        border: 1px solid #fff;
      }
    }

    .spinner-container{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

const TopPagesMap = () => {
  const dispatch = useDispatch();

  const {
    singleShipmentLoadItem,
    isLoadingGetSingleShipmentLoadItem
  } = useSelector((state) => state.loadList);

  const {
    isActiveSide,
    animationControlType,
    remainingDistance,
    pastKonumItemId,
    tekSuruculuTahminiVaris,
    ciftSuruculuTahminiVaris,


    topPagesMapAllShipmentCurrentLocationList,
    topPagesMapShipmentItemCurrentLocationData
  } = useSelector((state) => state.topPagesMap);

  const {multipleLocationDistance} = useSelector(state => state.distance)

  const initialCenterRef = useRef({ lat: 39.419221, lng: 34.343262 });

  const [hoveredVarisQuestion, setHoveredVarisQuestion] = useState(false)

  //! bu silinecek
  const [startDate, setStartDate] = useState(null)

  const location = useLocation().pathname 
  const isPreTripStage = location === "/yuklemede" || location === "/atananlar"

  // const [directionResponse, setDirectionResponse] = useState(null)

  //! son konum alma tarihini gösteren
  const getLastKonum = () => {
 
    const date = getPastDateAndTime(topPagesMapShipmentItemCurrentLocationData?.currentDriverLocation?.createdDate)?.formattedDate;
    const time = getPastDateAndTime(topPagesMapShipmentItemCurrentLocationData?.currentDriverLocation?.createdDate)?.formattedTime;

    return {
      date,
      time,
    };

  };

  //! şarj datasını getiren
  const getSarjData = () => {
    return (topPagesMapShipmentItemCurrentLocationData?.currentDriverLocation?.batteryLevel && parseInt(topPagesMapShipmentItemCurrentLocationData?.currentDriverLocation?.batteryLevel  * 100)) > 0 ? parseInt(topPagesMapShipmentItemCurrentLocationData?.currentDriverLocation?.batteryLevel  * 100) : "---"
  };

    useEffect(()=> {
      if(multipleLocationDistance && remainingDistance && ((startDate && !isPreTripStage) || (!startDate && isPreTripStage))){
        
        getTekSuruculuTahminiVaris(multipleLocationDistance, isPreTripStage ? multipleLocationDistance : remainingDistance, isPreTripStage ? addThreeHoursToISO(new Date().toISOString()) : startDate)
        getCiftSuruculuTahminiVaris(multipleLocationDistance, isPreTripStage ? multipleLocationDistance : remainingDistance, isPreTripStage ? addThreeHoursToISO(new Date().toISOString()) : startDate)
      }
    },[multipleLocationDistance, remainingDistance, startDate, isPreTripStage, singleShipmentLoadItem?.id])

    useEffect(() => {
      if(singleShipmentLoadItem?.id){

        setStartDate(singleShipmentLoadItem?.routePoints?.$values[0]?.routePointStartDate)

        const list = singleShipmentLoadItem?.routePoints?.$values.map(item => {
          return {TownIds: addLoadLocationData?.find(innerItem => innerItem?.location === item?.location)?.townId}
        })

        dispatch(getDistanceBetweenTwoTown(list))

      }
    },[singleShipmentLoadItem?.id])


    // useEffect(()=> {

    //   return () => {
    //       dispatch(resetAllState())
    //    }

    //  },[])


  return (
    <Container>
      <GoogleMap
        center={initialCenterRef.current}
        zoom={6}
        mapContainerStyle={{
          height: "100%",
          width: isActiveSide ? `calc(100% - 260px)` : "100%",
        }}
      >
      
      {singleShipmentLoadItem?.id && 
        <Marker
          position={{
            lat: parseFloat(singleShipmentLoadItem?.routePoints?.$values[singleShipmentLoadItem?.routePoints?.$values?.length-1]?.lat),
            lng: parseFloat(singleShipmentLoadItem?.routePoints?.$values[singleShipmentLoadItem?.routePoints?.$values?.length-1].lng)
          }}
          icon={{
            url: bayrakk,
            anchor: new window.google.maps.Point(0, 32),
            size: new window.google.maps.Size(20, 32),
            origin: new window.google.maps.Point(0, 0),
          }}
        />
      }

        <MarkerClusterer averageCenter={true} gridSize={60}>
          {(clusterer) => (
            <>
              {topPagesMapAllShipmentCurrentLocationList.map((item, i) => (
                <MemoizedOverlayDriverLocation
                  key={i}
                  position={{
                    lat: parseFloat(item?.currentDriverLocation?.lat),
                    lng: parseFloat(item?.currentDriverLocation?.lng),
                  }}
                  isActive={topPagesMapShipmentItemCurrentLocationData?.shipmentId === item?.shipmentId}
                  imageUrl={
                    item?.driverInfo?.profilePhoto
                      ? `${process.env.REACT_APP_API_IMG_URI}${item?.driverInfo?.profilePhoto}`
                      : avatar
                  }
                  animationControlType={animationControlType}
                  handleClick={() => {
                    dispatch(getSingleShipmentLoadItem(item.shipmentId));
                    dispatch(setTopPagesMapShipmentItemCurrentLocationData(item.shipmentId))
                    dispatch(setIsActiveSide(true));
                  }}
                />
              ))}
            </>
          )}
        </MarkerClusterer>

        {/* //! burası direction ile ilgili kalkması lazım */}
        {/* {
          (singleShipmentLoadItem?.id && directionResponse) && (
            <DirectionsRenderer directions={directionResponse}options={directionOptions}/>
          )
        } */}
       
      </GoogleMap>
      {isActiveSide && (
        <div className="map-side-container">
          {(singleShipmentLoadItem && !isLoadingGetSingleShipmentLoadItem) ? (
            <>
              <div className="side-top-container">
                <div className="top-data-container">
                  <span
                    className="top-data-name"
                    onClick={() => {
                      singleShipmentLoadItem?.driverPhoneNumber && dispatch(setSelectUserData(singleShipmentLoadItem?.driverPhoneNumber)); dispatch(showNestedModal("surucuProfil"));
                    }}
                  >{singleShipmentLoadItem.driverName}</span>
                  <span className="top-data-phone">{singleShipmentLoadItem?.driverPhoneNumber} </span>
                </div>
                <div
                  className="top-img-container"
                  onClick={() => {
                    dispatch(setSelectUserData( singleShipmentLoadItem?.driverPhoneNumber ));
                    dispatch(showNestedModal("surucuProfil"));
                  }}
                >
                  <img
                    src={singleShipmentLoadItem.userProfilePhoto? `https://egeyurtgrupbucket.s3.eu-north-1.amazonaws.com/Images/${singleShipmentLoadItem?.userProfilePhoto}` : avatar}
                    alt="Profile photo"
                  />
                </div>
              </div>
              <div className="side-mid-container">
                <div className="side-mid-item">
                  Nereden:{" "}
                  {singleShipmentLoadItem?.routePoints?.$values[0]?.city} - {" "}
                  {singleShipmentLoadItem?.routePoints?.$values[0]?.town}
                </div>
                <div className="side-mid-item">
                  Nereye:{" "}
                  {singleShipmentLoadItem?.routePoints?.$values[singleShipmentLoadItem?.routePoints?.$values?.length - 1]?.city}
                  -{" "}
                  {singleShipmentLoadItem?.routePoints?.$values[singleShipmentLoadItem?.routePoints?.$values?.length - 1]?.town}
                </div>
                <div className="side-mid-item">
                  Plaka:{" "}
                  {singleShipmentLoadItem?.waitinLoad?.aspiredLoads?.$values[0]?.truckPlateNumber || singleShipmentLoadItem?.truckPlateNumber || singleShipmentLoadItem?.trailerPlateNumber || singleShipmentLoadItem?.waitinLoad?.aspiredLoads?.$values[0]?.trailerPlateNumber ||  "---"}
                </div>
                <div className="side-mid-item varis" style={{display: "flex", flexDirection: "column"}}>
                  <div className="tahmini-varis-container">Tahmini Varış
                    <span className="question-mark" onMouseEnter={() => setHoveredVarisQuestion(true)} onMouseLeave={() => setHoveredVarisQuestion(false)}>?</span>
                    {
                      hoveredVarisQuestion &&
                      <>
                        <p>
                          Burada belirtilen bilgiler boşaltma noktasına tahmini varış bilgileridir.
                          Ticari araçların kanuni hız sınırları ile takografa uyumlu olarak kanuni sürüş ve dinlenme süreleri dikkate alınarak hesaplanmaktadır.
                          Kesin bir tarih ve saat olarak dikkate alınmamalıdır. 
                          Bilgi vermek amacıyla hesaplanıp gösterilmektedir.
                          Tek sürücülü ve çift sürücülü olmasına göre değişmektedir.
                        </p>
                        <TbTriangleInvertedFilled className="arr"/>
                      </>
                    }
                  </div>
                  <div>
                      Tek Sürücülü: 
                    {/* {tekSuruculuTahminiVaris?.formattedDate && tekSuruculuTahminiVaris?.formattedDate} {" - "}
                    {tekSuruculuTahminiVaris?.formattedTime && tekSuruculuTahminiVaris?.formattedTime} */}
                  </div>
                  <div>
                      Çift Sürücülü: 
                      {/* {ciftSuruculuTahminiVaris?.formattedDate && ciftSuruculuTahminiVaris?.formattedDate} {" - "}
                      {ciftSuruculuTahminiVaris?.formattedTime && ciftSuruculuTahminiVaris?.formattedTime} */}
                  </div>
                </div>
                <div className="side-mid-item">
                  Şarj Bilgisi: %{getSarjData(singleShipmentLoadItem?.id)}
                </div>
                <div className="side-mid-item">
                  Son konum Alma:{" "}
                  {
                    topPagesMapShipmentItemCurrentLocationData?.currentDriverLocation &&
                    <>
                      {new Date(topPagesMapShipmentItemCurrentLocationData?.currentDriverLocation.createdDate).getDate()}:0{new Date(topPagesMapShipmentItemCurrentLocationData.currentDriverLocation.createdDate).getDay()}:
                      {new Date(topPagesMapShipmentItemCurrentLocationData?.currentDriverLocation.createdDate).getFullYear()}-
                      {new Date(topPagesMapShipmentItemCurrentLocationData?.currentDriverLocation.createdDate).getHours()}:
                      {new Date(topPagesMapShipmentItemCurrentLocationData?.currentDriverLocation.createdDate).getMinutes()}
                  </>
                }
                </div>
              </div>

              <div className="side-bottom-container">
                <button onClick={() => {dispatch(showModal("topPagesWideMap")); dispatch(getShipmentDriverLocationsById({fromWhere: null, shipmentId: singleShipmentLoadItem.id}))}}>
                {/* <button onClick={() => {dispatch(getShipmentDriverLocationsById({fromWhere: null, shipmentId: singleShipmentLoadItem.id}))}}> */}
                  Detaylı Görünüm
                </button>
              </div>
            </>
          ) : (
            <div className="spinner-container">
              <SmallSpinner size={"30px"} color={"#fff"} bgColor={"#E85446"}/>
            </div>
          )}
        </div>
      )}
    </Container>
  );
};

export default TopPagesMap;
